import { useCallback } from 'react';
import styled from 'styled-components';
import I18n from 'I18n';
import { TableCell } from 'foundations-components/transitional/components/Table';
import { SummaryRecipientsContactCellCHIRP } from './SummaryRecipientsContactCellCHIRP';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledRow = styled.tr.withConfig({
  displayName: "SummaryRecipientsTableRowCHIRP__StyledRow"
})(["cursor:pointer;"]);
export const SummaryRecipientsTableRowCHIRP = ({
  documentVisitor,
  onViewDetails
}) => {
  const lastViewedValue = (documentVisitor === null || documentVisitor === void 0 ? void 0 : documentVisitor.lastViewed) || 0;
  const lastViewed = I18n.moment.userTz(lastViewedValue).fromNow();
  const views = documentVisitor === null || documentVisitor === void 0 ? void 0 : documentVisitor.views;
  const handleViewDetails = useCallback(() => {
    onViewDetails(documentVisitor);
  }, [documentVisitor, onViewDetails]);
  return /*#__PURE__*/_jsxs(StyledRow, {
    "data-test-id": "summary-recipients-table-row",
    onClick: handleViewDetails,
    children: [/*#__PURE__*/_jsx(SummaryRecipientsContactCellCHIRP, {
      documentVisitor: documentVisitor,
      onViewDetails: handleViewDetails
    }), /*#__PURE__*/_jsx(TableCell, {
      textAlign: "right",
      children: views.toString()
    }), /*#__PURE__*/_jsx(TableCell, {
      textAlign: "right",
      children: lastViewed
    })]
  });
};